import { message } from "antd";
import axiosInstance from "../shared/axios";

const getAllMedicines = async (params) => {
  try {
    const result = await axiosInstance.get("/medicine/viewAll", {
      params: {
        name: params?.name || "",
        status: params?.status ?? null,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading medicines");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading medicines",
    );
    return { data: [], total: 0 };
  }
};

const getMedicineGroupLookUp = async () => {
  try {
    let result = await axiosInstance.get("/medicine-group/options");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("error", "Error while loading medicines group");
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading medicines group");
    return null;
  }
};

const addEditMedicines = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/medicine/update" : "/medicine/create",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save medicines",
    };
  }
};

const deleteMedicine = async (id) => {
  try {
    const result = await axiosInstance.delete(`/medicine/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete medicine",
    };
  }
};

const updateMedicinesStatus = async ({ id, isActive }) => {
  try {
    let result = await axiosInstance?.post(`/medicine/updateStatus`, {
      id,
      IsActive: Boolean(isActive),
    });
    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      return {
        success: false,
        message: result?.data?.message || "Failed to update medicine status",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update medicine status",
    };
  }
};

export const medicinesapi = {
  getAllMedicines,
  addEditMedicines,
  deleteMedicine,
  getMedicineGroupLookUp,
  updateMedicinesStatus,
};
